<template>
  <a-form layout="vertical" class="form" ref="formRef" :model="formState" :rules="rules">
    <h1>Completa los nombres de la plantilla</h1>
    <h3>Nombre para realizar la solicitud a WhatsApp</h3>
    <p>
      El nombre debe ser en minúsculas, separado por un guión bajo, sin espacios y sin caracteres
      especiales. Ejemplo: recordatorio_de_pago
    </p>

    <a-form-item label="Nombre de plantilla" name="name">
      <a-input v-model:value="formState.name" placeholder="Escribir nombre de la plantilla" />
    </a-form-item>

    <h3>Nombre de visualización en {{ ProductName }}</h3>
    <p>Este nombre será el que tus usuarios visualizarán en la plataforma.</p>

    <a-form-item label="Nombre de visualización" name="display_name">
      <a-input
        v-model:value="formState.display_name"
        placeholder="Escribir nombre de visualización"
      />
    </a-form-item>
  </a-form>
</template>

<script>
import { defineComponent, reactive, ref, watch } from "vue";
import { ProductName } from "@/app/shared/utils/constants";

export default defineComponent({
  props: {
    templatesData: {
      required: true,
      type: Array,
    },
  },
  setup(props, { emit, expose }) {
    const formRef = ref(null);

    const formState = reactive({
      name: "",
      display_name: "",
    });

    watch(formState, () => {
      if (formState.name && formState.display_name) {
        formRef.value
          .validate()
          .then(() => emit("active-button"))
          .catch(() => emit("inactive-button"));

        return;
      }

      return emit("inactive-button");
    });

    const hasMatch = async (key = "name", value) => {
      const match = props.templatesData.some((template) => template[key] === value);

      return match;
    };

    const validateTemplateName = async (rule, value) => {
      const isValid = Boolean(value?.match(/^[a-z0-9_]*$/g));

      if (!value) return Promise.reject("El campo es requerido");

      if (!isValid) return Promise.reject("El nombre no es válido");

      const hasNameMatch = await hasMatch("name", value);

      if (hasNameMatch) return Promise.reject("El nombre debe ser único");

      return Promise.resolve();
    };

    const validateDisplayName = async (rule, value) => {
      const hasDisplayMatch = await hasMatch("display_name", value);

      if (hasDisplayMatch) return Promise.reject("El nombre de visualización debe ser único");

      return Promise.resolve();
    };

    const rules = {
      name: [{ required: true, validator: validateTemplateName }],
      display_name: [{ required: true, validator: validateDisplayName }],
    };

    expose({ formState });

    return { formRef, formState, rules, ProductName };
  },
});
</script>

<style lang="sass" scoped>
.form
  color: $gray-9

h3
  font-size: 16px
  font-weight: 600

p
  color: $gray-8

small
  font-size: 14px
  color: $gray-7
</style>
